module.exports = __webpack_public_path__ + "static/media/mrkhwarizmi.f0fbd533.gif";